import React from 'react'
import formattedCreditsWithHoursShort from '@Utils/FormattedCreditsWithHoursShort'

import './AssetsTableHeader.scss'

interface AssetsTableHeaderProps {
  readonly currentWorkspaceName: string
  readonly totalCountOfElements: number
  readonly availableTotalCredits: number
}

const AssetsTableHeader: React.FC<AssetsTableHeaderProps> = props => {
  const {
    currentWorkspaceName,
    totalCountOfElements,
    availableTotalCredits,
  } = props

  const renderAssetsTableHeaderTop = () => {
    return (
      <div className="AssetsTableHeader__top">
        {renderAssetsTableHeaderTopLeft()}
        {renderAssetsTableHeaderTopRight()}
      </div>
    )
  }

  const renderAssetsTableHeaderTopLeft = () => {
    return (
      <div className="AssetsTableHeader__top-left">
        <div className="AssetsTableHeader__workspace-name">
          {currentWorkspaceName}
        </div>
        <div className="AssetsTableHeader__number-of-assets">
          {totalCountOfElements === 1 ? '1 asset' : `${totalCountOfElements} assets`}
        </div>
      </div>
    )
  }

  const renderAssetsTableHeaderTopRight = () => {
    return (
      <div className="AssetsTableHeader__top-right">
        <div className="AssetsTableHeader__credits-remaining">
          {`${formattedCreditsWithHoursShort(availableTotalCredits)} credits remaining`}
        </div>
      </div>
    )
  }

  return (
    <div className="AssetsTableHeader">
      {renderAssetsTableHeaderTop()}
    </div>
  )
}

export default AssetsTableHeader
